export default __webpack_public_path__ + "static/media/gift_post_help.11dc26b3.png";